/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';

// core components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Footer from 'components/Footer/Footer.js';
import Sidebar from 'components/Sidebar/Sidebar.js';
import FixedPlugin from 'components/FixedPlugin/FixedPlugin.js';

import routes from 'routes.js';

import logo from 'assets/img/react-logo.png';
import { BackgroundColorContext } from 'contexts/BackgroundColorContext';
import { Card, CardBody, Row, Col, Button, Modal, FormGroup, Label, Input } from 'reactstrap';

var ps;

function renderIf(condition, trueComponent, falseComponent) {
	if (condition === true) {
		return trueComponent;
	} else {
		return falseComponent;
	}
}

function getSessionData(params) {
	return window.sessionStorage.getItem(params);
}

function Admin(props) {
	const location = useLocation();
	const mainPanelRef = React.useRef(null);
	const [sidebarOpened, setsidebarOpened] = React.useState(document.documentElement.className.indexOf('nav-open') !== -1);
	React.useEffect(() => {
		if (navigator.platform.indexOf('Win') > -1) {
			document.documentElement.className += ' perfect-scrollbar-on';
			document.documentElement.classList.remove('perfect-scrollbar-off');
			ps = new PerfectScrollbar(mainPanelRef.current, {
				suppressScrollX: true,
			});
			let tables = document.querySelectorAll('.table-responsive');
			for (let i = 0; i < tables.length; i++) {
				ps = new PerfectScrollbar(tables[i]);
			}
		}
		// Specify how to clean up after this effect:
		return function cleanup() {
			if (navigator.platform.indexOf('Win') > -1) {
				ps.destroy();
				document.documentElement.classList.add('perfect-scrollbar-off');
				document.documentElement.classList.remove('perfect-scrollbar-on');
			}
		};
	});
	React.useEffect(() => {
		if (navigator.platform.indexOf('Win') > -1) {
			let tables = document.querySelectorAll('.table-responsive');
			for (let i = 0; i < tables.length; i++) {
				ps = new PerfectScrollbar(tables[i]);
			}
		}
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
		if (mainPanelRef.current) {
			mainPanelRef.current.scrollTop = 0;
		}
	}, [location]);
	// this function opens and closes the sidebar on small devices
	const toggleSidebar = () => {
		document.documentElement.classList.toggle('nav-open');
		setsidebarOpened(!sidebarOpened);
	};
	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			if (prop.layout === '/admin') {
				return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
			} else {
				return null;
			}
		});
	};
	const getBrandText = (path) => {
		for (let i = 0; i < routes.length; i++) {
			if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
				return routes[i].name;
			}
		}
		return 'Brand';
	};

	setInterval(() => {
		if (getSessionData('VToken') === null) {
			window.location.reload();
		}
	}, (10 + 60) * 1000);

	return (
		<BackgroundColorContext.Consumer>
			{({ color, changeColor }) => (
				<React.Fragment>
					<div className='wrapper'>
						{renderIf(getSessionData('VToken') === null, <Login />)}
						<Sidebar
							routes={routes}
							logo={{
								outterLink: '',
								text: 'Drakgon Industries',
								imgSrc: logo,
							}}
							toggleSidebar={toggleSidebar}
						/>
						<div className='main-panel' ref={mainPanelRef} data={color}>
							<AdminNavbar brandText={getBrandText(location.pathname)} toggleSidebar={toggleSidebar} sidebarOpened={sidebarOpened} />
							<Switch>
								{getRoutes(routes)}
								<Redirect from='*' to='/admin/dashboard' />
							</Switch>
							{
								// we don't want the Footer to be rendered on map page
								location.pathname === '/admin/maps' ? null : <Footer fluid />
							}
						</div>
					</div>
					<FixedPlugin bgColor={color} handleBgClick={changeColor} />
				</React.Fragment>
			)}
		</BackgroundColorContext.Consumer>
	);
}

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalDemo: true,
			Vtoken: '',
			wrong: '',
			User: '',
			Password: '',
		};
		this.toggleModalDemo = this.toggleModalDemo.bind(this);
	}
	toggleModalDemo() {
		if (this.state.Vtoken !== '') {
			this.setState({
				modalDemo: !this.state.modalDemo,
			});
		}
		if (this.state.Vtoken === '') {
			this.setState({
				wrong: 'Inicie sesión caballero',
			});
		}
	}

	handleUser(event) {
		this.setState({ User: event.target.value });
	}
	handlePassword(event) {
		this.setState({ Password: event.target.value });
	}
	submit() {
		var xhr2 = new XMLHttpRequest();
		xhr2.addEventListener('load', () => {
			if (xhr2.readyState === 4 && xhr2.status === 200) {
				var initJson = (data) => {
					return new Promise((resolve, reject) => {
						resolve(JSON.parse(data));
					});
				};
				initJson(xhr2.responseText).then((validation) => {
					if (validation.verificado === true && validation.vtoken !== undefined) {
						// eslint-disable-next-line
						if (validation.active == true) {
							window.sessionStorage.setItem('VToken', validation.vtoken);
							window.sessionStorage.setItem('UToken', validation.utoken);
							window.sessionStorage.setItem('Owner', validation.username);
							window.sessionStorage.setItem('linkback', validation.linkback);
							window.sessionStorage.setItem('linkcpa', validation.linkcpa);
							window.sessionStorage.setItem('typeofuser', validation.typeofuser);

							this.setState({ good: 'Todo bien, pase' }, () => {
								setTimeout(() => {
									this.setState({ modalDemo: !this.state.modalDemo });
									window.location.reload();
								}, 2000);
							});
						} else {
							this.setState({ wrong: 'Billy a que hora el pago?' });
						}
					} else if (validation.verificado === false || validation.vtoken === false) {
						this.setState({ wrong: 'Ponga eso bien varon' });
					} else {
						this.setState({ wrong: 'Hubo un error en su solicitud' });
					}
				});
			}
		});

		xhr2.open('POST', `${process.env.REACT_APP_BACKEND_URL}/login?username=${this.state.User}&password=${this.state.Password}`);

		xhr2.send();
	}

	_handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			this.submit();
		}
	};

	render() {
		return (
			<Modal isOpen={this.state.modalDemo} toggle={this.toggleModalDemo}>
				<Card style={{ marginBottom: 0 + 'px' }}>
					<CardBody>
						<form>
							<FormGroup>
								<Label for='exampleEmail'>
									<p className='text-primary'>
										<strong>USUARIO</strong>
									</p>
								</Label>
								<Input
									type='email'
									name='email'
									id='exampleEmail'
									placeholder='Entrar Usuario'
									onChange={this.handleUser.bind(this)}
									value={this.state.User}
								/>
							</FormGroup>
							<FormGroup>
								<Label for='examplePassword'>
									<p className='text-primary'>
										<strong>PASSWORD</strong>
									</p>
								</Label>
								<Input
									type='password'
									name='password'
									id='examplePassword'
									placeholder='Password'
									autoComplete='off'
									onChange={this.handlePassword.bind(this)}
									value={this.state.Password}
									onKeyDown={this._handleKeyDown}
								/>
							</FormGroup>
						</form>

						<Row>
							<Col xs='auto'>
								<p className='text-warning'>{this.state.wrong}</p>
								<p className='text-success'>{this.state.good}</p>
							</Col>
							<Button
								color='success'
								className='animation-on-hover '
								onClick={() => {
									this.submit();
								}}
								style={{ marginLeft: 'auto', marginRight: 1 + 'rem' }}
							>
								A Romper
							</Button>
						</Row>
					</CardBody>
				</Card>
			</Modal>
		);
	}
}

export default Admin;
